import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { updateCostRecord } from '../state';
import { CostRecordView } from '../../../types/shared/accessRequestTypes';

/**
 * Custom hook that abstracts Redux state selection and dispatch for
 * Cost Record editors. Returns cost record state and an update function
 * that dispatches partial updates to the ticket's costRecord.
 *
 * Used by both PM and FAC ticket categories.
 */
export const useCostEditor = () => {
  const dispatch = useAppDispatch();

  const costRecord = useAppSelector(state =>
    state.ticket.currentTicket?.costRecord
  );

  const updateCostField = useCallback(
    (update: Partial<CostRecordView>) => {
      dispatch(updateCostRecord(update));
    },
    [dispatch]
  );

  return { costRecord, updateCostField };
};
